// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"a29551bc","350":"1d94f94f","787":"6111644d"}[chunkId] + ".chunk.js";
};